import { render, staticRenderFns } from "./RightClickWrapMenu.vue?vue&type=template&id=29c8c084&scoped=true&"
import script from "./RightClickWrapMenu.vue?vue&type=script&lang=ts&"
export * from "./RightClickWrapMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8c084",
  null
  
)

export default component.exports